import { inject, injectable } from 'inversify';
import { Observable, Subject, filter } from 'rxjs';
import { SERVICE_ID } from '@di/serviceId';
import type { Logger } from '@core/model/domain/logger';
import { BrowserBroadcast, TabMessagesLabels, TabsEvent } from './browserBroadcast';

@injectable()
export class BroadcastChannelBrowserBroadcast implements BrowserBroadcast {
  private broadcastChannel: BroadcastChannel;
  private onMessage = new Subject<TabsEvent<TabMessagesLabels>>();

  constructor(@inject(SERVICE_ID.logger) private readonly logger: Logger) {
    this.broadcastChannel = new BroadcastChannel('open_banking_browser_broadcast');
    this.broadcastChannel.onmessage = (message: MessageEvent<TabsEvent<TabMessagesLabels>>) => {
      this.onMessage.next(message.data);
      this.logger.logEvent(`open_banking_browser_broadcast message received`, message.data);
    };
  }

  publish(message: TabsEvent<TabMessagesLabels>): void {
    this.broadcastChannel.postMessage(message);
    this.logger.logEvent(`open_banking_browser_broadcast message published`, message);
  }

  getMessageFromLabel<TLabel extends TabMessagesLabels>(label: TLabel): Observable<TabsEvent<TLabel>> {
    return this.onMessage.pipe(filter((message) => message.label === label)) as Observable<TabsEvent<TLabel>>;
  }
}
